import { render, staticRenderFns } from "./SetFieldsDialog.vue?vue&type=template&id=0d8d8af4&scoped=true"
import script from "./SetFieldsDialog.vue?vue&type=script&lang=js"
export * from "./SetFieldsDialog.vue?vue&type=script&lang=js"
import style0 from "./SetFieldsDialog.vue?vue&type=style&index=0&id=0d8d8af4&prod&lang=scss"
import style1 from "./SetFieldsDialog.vue?vue&type=style&index=1&id=0d8d8af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d8af4",
  null
  
)

export default component.exports